var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import React, { Component, createRef, Suspense } from "react";
import { addDevToolsClickListener, Version } from "./../wix-rich-content-common";
import { RicosDevToolsLazy, shouldShowDebuggingInfo } from "./../wix-rich-content-common/lib/devTools";
import { getContentSummary } from "./../wix-rich-content-common/lib/ricosContentAnalytics";
import { getBiCallback as getCallback } from "./biUtils";
import { ContentViewer } from "./ContentViewer";
import FullscreenProvider from "./modals/fullscreen/FullscreenProvider";
import { hasFullscreen, mergeViewerProps } from "./utils";
class RicosViewerNext extends Component {
  constructor(props) {
    super(props);
    __publicField(this, "viewerRef");
    __publicField(this, "getBiCallback");
    __publicField(this, "loadTextSelection", () => {
      const { textSelectionToolbar, isMobile } = this.props;
      const needTextSelectionToolbar = textSelectionToolbar && !isMobile;
      if (needTextSelectionToolbar && !this.state.TextSelectionToolbar) {
        const TextSelectionToolbar = React.lazy(() => import("./TextSelectionToolbar"));
        this.setState({ TextSelectionToolbar });
      }
    });
    __publicField(this, "loadLinkPreviewPopover", () => {
      const { linkPreviewPopoverFetchData, isMobile } = this.props;
      const needLoadLinkPreviewPopover = linkPreviewPopoverFetchData && !isMobile;
      if (needLoadLinkPreviewPopover && !this.state.LinkPreviewPopover) {
        const LinkPreviewPopover = React.lazy(() => import("./LinkPreviewPopover"));
        this.setState({ LinkPreviewPopover });
      }
    });
    __publicField(this, "onMouseOver", () => {
      this.loadTextSelection();
      this.loadLinkPreviewPopover();
    });
    this.getBiCallback = getCallback.bind(this);
    this.viewerRef = createRef();
    this.state = {};
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, errorInfo) {
    console.error({ error, errorInfo });
  }
  componentDidMount() {
    const onViewerLoaded = this.getBiCallback("onViewerLoaded");
    const content = this.props.content || this.props._rcProps?.content;
    const { pluginsCount } = content && getContentSummary(content) || {};
    pluginsCount && onViewerLoaded?.({
      isPreview: false,
      version: Version.currentVersion,
      pluginsCount,
      url: document.URL,
      contentId: content?.metadata?.id
    });
    addDevToolsClickListener(
      this.viewerRef.current,
      () => this.setState({ debugInvokedWithMouse: true })
    );
  }
  render() {
    const {
      seoSettings,
      linkPreviewPopoverFetchData,
      mediaSettings,
      isMobile,
      content,
      experiments,
      debugMode
    } = this.props;
    const { TextSelectionToolbar, LinkPreviewPopover } = this.state;
    const mergedProps = mergeViewerProps({
      ...this.props,
      viewerProps: {
        seoMode: seoSettings,
        onMouseOver: this.onMouseOver,
        locale: this.props.locale
      }
    });
    let contentViewer = /* @__PURE__ */ React.createElement(
      ContentViewer,
      {
        ...mergedProps,
        key: "viewer",
        setRef: this.viewerRef,
        devTools: this.state.debugInvokedWithMouse || shouldShowDebuggingInfo(debugMode?.includes("all")) ? /* @__PURE__ */ React.createElement(React.Suspense, null, /* @__PURE__ */ React.createElement(
          RicosDevToolsLazy,
          {
            version: Version.currentVersion,
            mode: "viewer",
            contentState: content,
            ricosProps: this.props,
            autoOpen: this.state.debugInvokedWithMouse ?? false
          }
        )) : null
      }
    );
    if (hasFullscreen(mergedProps.config)) {
      contentViewer = /* @__PURE__ */ React.createElement(
        FullscreenProvider,
        {
          key: "RicosFullscreenProvider",
          fullscreenProps: mediaSettings?.fullscreenProps,
          isMobile: !!isMobile,
          content,
          experiments
        },
        contentViewer
      );
    }
    try {
      if (this.state.error) {
        this.props.onError?.(this.state.error);
        return null;
      }
      return [
        contentViewer,
        TextSelectionToolbar ? /* @__PURE__ */ React.createElement(Suspense, { key: "TextSelectionToolbar", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          TextSelectionToolbar,
          {
            onButtonClick: this.getBiCallback("onViewerAction"),
            container: this.viewerRef.current
          }
        )) : null,
        LinkPreviewPopover ? /* @__PURE__ */ React.createElement(Suspense, { key: "LinkPreviewPopover", fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
          LinkPreviewPopover,
          {
            fetchUrlPreviewData: linkPreviewPopoverFetchData,
            container: this.viewerRef.current
          }
        )) : null
      ];
    } catch (e) {
      this.props.onError?.(e);
      return null;
    }
  }
}
__publicField(RicosViewerNext, "displayName", "RicosViewerNext");
__publicField(RicosViewerNext, "defaultProps", {
  onError: (err) => {
    throw err;
  }
});
var RicosViewerNext_default = RicosViewerNext;
export {
  RicosViewerNext_default as default
};
//# sourceMappingURL=RicosViewerNext.js.map
